import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { LoyaltyProgramApiService } from '@features/loyalty-program/services/loyalty-program-api/loyalty-program-api.service';
import { HttpError } from '@rd/types';
import { Observable, of } from 'rxjs';
import {
  catchError,
  debounceTime,
  first,
  map,
  startWith,
  switchMap,
  take,
} from 'rxjs/operators';

export class MembershipNumberValidator {
  static validateMembershipNumber(
    loyaltyProgramApiService: LoyaltyProgramApiService,
    loyaltyProgramId: string,
  ): AsyncValidatorFn {
    return (
      c: AbstractControl,
    ): Observable<{ membershipNumberInvalid: boolean } | null> => {
      if (!c || (!c.value && c.value !== '')) {
        return of(null);
      }

      // Below line is to trigger the validation without having to move the focus out of the input field
      c.markAsTouched();

      return c.valueChanges
        .pipe(
          startWith(c.value),
          debounceTime(500),
          switchMap((value) =>
            loyaltyProgramApiService
              .postMembershipValidation(loyaltyProgramId, value)
              .pipe(
                first(),
                catchError((err: HttpError) => {
                  return of(false);
                }),
              ),
          ),
          map((valid) =>
            valid === true ? null : { membershipNumberInvalid: true },
          ),
        )
        .pipe(take(1));
    };
  }
}
